import { useEffect, useState } from "react";
import * as tmImage from "@teachablemachine/image";
import { sleep } from "../utils/common";

const URL = "https://teachablemachine.withgoogle.com/models/Zu6EtTJ2c/";

const modelURL = `${URL}model.json`;
const metadataURL = `${URL}metadata.json`;

const useAI = () => {
  const [model, setModel] = useState<tmImage.CustomMobileNet>();
  const [loading, setLoading] = useState(false);

  const predict = async (image: tmImage.ClassifierInputSource) => {
    if (model) {
      setLoading(true);
      await sleep(1500);
      const prediction = await model.predict(image);
      setLoading(false);

      console.log(prediction.sort((a, b) => b.probability - a.probability));
      return prediction.sort((a, b) => b.probability - a.probability);
    }
  };

  useEffect(() => {
    const asyncFunc = async () => {
      setLoading(true);
      const temp = await tmImage.load(modelURL, metadataURL);
      setModel(temp);

      setLoading(false);

      const maxPredictions = temp.getTotalClasses();
      console.log("maxPredictions: ", maxPredictions);
    };
    asyncFunc();
  }, []);

  return { predict, loading };
};

export default useAI;
